module.exports = __webpack_public_path__ + "img/result-oman-03.3da234eb.svg";